<template>
	<section class="container-facts" :id="[index]">
		<div class="container">
			<h2>{{ energyData.config.title }}</h2>
			<div class="row">
				<div class="col">
					<div class="row energy" v-bind:class="{ active: isActive }">
						<FactsItem :factsItemData="energyData" isMultiblock="false" />
					</div>
				</div>
				<div class="col-xl-6 energy-picture d-flex justify-content-center align-item-center"
					v-if="energyData.config.showScala == true">
					<img :src="`${energyData.config.path}`" />
				</div>
			</div>
		</div>
	</section>
</template>


<script>
import FactsItem from "./FactsItem.vue";

export default {
	components: {
		FactsItem
	},
	props: {
		energyData: {
			type: Object
		},
		index: {
			type: Number
		},
		isMultiblock: {
			type: String
		}
	},

	data() {
		return {
			isActive: false,


		}
	},

	mounted() {
		if (this.energyData.config.showScala == true) {
			this.isActive = true;
		}
	},
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/design-wien/energyDataComponent.scss";
</style>
